var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.38559 13.444L1.61529 8.67371C1.42746 8.48886 1.33504 8.24438 1.33504 7.9999C1.33504 7.75543 1.42821 7.51154 1.61455 7.3255L6.38485 2.55521C6.75753 2.18253 7.36127 2.18253 7.73395 2.55521C8.10663 2.92788 8.10663 3.53163 7.73395 3.9043L4.59077 7.04584L13.7378 7.04584C14.2652 7.04584 14.665 7.47308 14.665 7.97307C14.665 8.47306 14.2652 8.95396 13.7378 8.95396L4.59077 8.95396L7.7332 12.0964C8.10588 12.4691 8.10588 13.0728 7.7332 13.4455C7.36052 13.8182 6.75827 13.8167 6.38559 13.444Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.2626340e5cb8ff52db41a88d1cff1e3b.svg";
export { ForwardRef as ReactComponent };